import Vue from 'vue';
import axios from "axios";

export const http = axios.create({
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
    },
});

http.interceptors.response.use(response => {
    return response;
}, error => {

    switch (error.response.status) {
        case 404:
        case 500:
            Vue.$toast.error(`${error}`);
            break;
        default:
            Vue.$toast.error(error.response.data);
            break;
    }

    return error;
});
